(() => {
  const metrics = nav => {
    if (!nav.isConnected) return;
    const style = document.documentElement.style;
    style.setProperty('--akira-nav-height', nav.offsetHeight + 'px');
    style.setProperty('--akira-nav-top', Math.max(0, nav.getBoundingClientRect().top) + 'px');
    style.setProperty('--akira-nav-toggle-height', nav.querySelector('[data-akira-toggle]').offsetHeight + 'px');
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-family-sticky-menu]').forEach(nav => {
      if (nav.dataset.akiraNavReady) return;
      nav.dataset.akiraNavReady = 'true';
      const container = nav.closest('[id^="shopify-section-"]') || nav;
      container.setAttribute('data-family-sticky-menu-container', '');
      const toggle = nav.querySelector('[data-akira-toggle]');
      metrics(nav);
      if (window.ResizeObserver) new ResizeObserver(() => metrics(nav)).observe(nav);
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        nav.classList.toggle('is-open', !open);
        metrics(nav);
      });
      nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const branch = event.target.closest('details[open]');
        if (branch) { branch.open = false; branch.querySelector('summary').focus(); }
        else { nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
      });
      document.addEventListener('click', event => {
        if (!nav.contains(event.target)) {
          nav.querySelectorAll('details[open]').forEach(branch => { branch.open = false; });
          nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (!window.akiraNavMetricsInstalled) {
    window.akiraNavMetricsInstalled = true;
    let queued = false;
    const update = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; document.querySelectorAll('[data-family-sticky-menu]').forEach(metrics); });
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }
})();
